export default `<div style="margin-top:1em;">
    <p>On December 30, 2022, FutureX Capital’s portfolio company Cryofocus Medtech (Shanghai) Co., Ltd. (“Cryofocus”)
        was listed on the Main Board of The Stock Exchange of Hong Kong Limited (HKSE: 6922). As Cryofocus Medtech’s
        Series B investor, we are optimistic about the leadership position of the company in the cryoablation industry
        and mass adoption of its technology in the future.</p>

    <p  class="img"><img src="/storage/app/media/uploaded-files/1.png" style="width: 503px;"
            class="fr-fic fr-dib" data-result="success"></p>

    <p>Founded in Shanghai in 2013, Cryofocus is the first China-based company with its unique liquid nitrogen
        cryoablation technology. With a primary focus on the field of minimally-invasive interventional cryotherapy,
        Cryofocus proprietarily developed a series of innovative medical devices. Its comprehensive product pipeline
        covers a wide variety of therapeutic areas with huge market potentials, such as cardiovascular intervention,
        respiratory intervention, urological intervention and gastrointestinal intervention. Several of its
        self-developed products have been designated as “innovative medical devices” by the NMPA or its provincial
        counterparts, and/or “breakthrough device” by the U.S. FDA.</p>

    

    <p>Cryotherapy is a treatment method that freezes and destroys abnormal cells or diseased tissues through extremely
        low temperatures. Compared with traditional treatment methods such as open surgery and radiofrequency ablation,
        interventional cryotherapy has the advantages of being more economical, safer, with fewer side effects and a
        lower probability of postoperative complications. Meanwhile, interventional cryotherapy is easy for the surgeon
        to learn and perform, and usually requires less time to perform the procedure. Interventional cryotherapy is
        widely used for the diagnosis and treatment of cardiovascular diseases, respiratory diseases, benign and
        malignant tumors, and many other diseases. In China, with the issues of aging population and increased
        prevalence of chronic diseases, the domestic market for interventional cryotherapy devices has shown explosive
        growth. According to Frost &amp; Sullivan's forecast, the market size of interventional cryotherapy devices in
        China is expected to grow at an annualized rate of 49% from RMB 400million in 2020 to RMB 2.9billion in 2025 and
        reach RMB 11.2billion in 2030.</p>

    

    <p>With its unique liquid nitrogen technology and understanding of pain points of clinical procedures, Cryofocus has
        created a variety of products applicable to different treatments. Up to now, the company has 17 products under
        development and 6 commercialized non-cryotherapy products. Products for atrial fibrillation, hypertension and
        early bladder cancer have received special approval from the government. The company's core product, the cardiac
        cryoablation system for atrial fibrillation, is expected to be the first-of-its-kind product to be developed and
        manufactured by a Chinese company; the bladder cryoablation system is the only interventional cryotherapy device
        for the treatment of bladder cancer that has completed a pivotal clinical trial in the world; and the Cryofocus
        cryoablation system is expected to be the first cryoablation device approved for commercialization for the
        treatment of hypertension globally.</p>

    <p class="img"><img src="/storage/app/media/uploaded-files/2.png" style="width: 447px;"
            class="fr-fic fr-dib" data-result="success"></p>

    

    <p>As Cryofocus’s Series B investor, FutureX Capital has been supporting the company from its early innings, we are
        impressed by the foreward-looking and progressive executive team at Cryofocus. Despite volatile macro
        uncertainty and Covid situation in China, the entrepreneurial team has risen to the challenge and achieved the
        ultimate professionalism and efficiency in product development, clinical and approval processes. With the
        greatest confidence, we are proud to partner with such an innovative company that is committed to benefiting the
        patients and creating miracles.</p>
</div>`;
